import { Minus } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'ui/components/Button';
import { usePermissions } from '../../hooks/use-permissions';
import useShowAI from '../../hooks/use-show-ai';
import { getSidebarOpen, setSidebarOpen } from '../../store/uiSlice';
import { AiPageReviewModal } from './ai-page-review-modal';
import { FilterList } from './menu/filter-list';
import { SearchBar } from './menu/search-bar';
import { SearchButton } from './menu/search-button';

export const Menu = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showAI = useShowAI();
  const { isPermitted } = usePermissions();
  const [searchOpen, setSearchOpen] = useState(false);
  const sidebarOpen = useSelector(getSidebarOpen);
  const handleToggleSidebar = () => {
    dispatch(setSidebarOpen(!sidebarOpen));
  };
  const handleToggleSearch = () => {
    setSearchOpen((prev) => !prev);
  };

  return (
    <div className="flex flex-col gap-2 p-2.5 pb-0">
      <div className='flex flex-row'>
        {showAI && <AiPageReviewModal />}
        <div className="flex ml-auto">
          {isPermitted("collaborate-sidebar-minimise-icon") && (
            <Button
              leftIcon={<Minus size={18} />}
              onClick={handleToggleSidebar}
              size="icon"
              variant="ghost"
              toolTipPortal
              tooltip={t('menu.collapse_tooltip', 'Collapse the sidebar into a side widget')}
            />
          )}
          {/* <Button
            leftIcon={<Plus size={18} />}
            onClick={() => {
              chrome.runtime.sendMessage({
                type: 'SEND_LOVEABLE_INJECTION',
                content: 'Hello',
              }, (response) => {
                console.log(response);
              });
            }}
            size="icon"
            variant="ghost"
            toolTipPortal
            tooltip={t('menu.send_loveable_injection_tooltip', 'Send Loveable Injection')}
          /> */}

          {isPermitted("collaborate-sidebar-search") && (
            <SearchButton onToggle={handleToggleSearch} />
          )}
          {isPermitted("collaborate-sidebar-filters") && (
            <FilterList />
          )}
          {/* TODO - Add PagesPopout here */}
          {/* <PagesPopout siteId={siteId} /> */}
        </div>
      </div>
      {isPermitted("collaborate-sidebar-search") && (
        <SearchBar searchOpen={searchOpen} />
      )}

    </div>
  );
};